var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 118,
    viewBox: "0 0 204 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.187 53.2644H139.842V59.5719H147.827V53.2644H159.482C160.234 53.2624 160.969 53.0486 161.605 52.6476C162.24 52.2466 162.749 51.6746 163.075 50.9972C163.4 50.3198 163.527 49.5645 163.443 48.818C163.358 48.0714 163.065 47.3637 162.597 46.7762L151.82 33.3007H153.817C154.558 33.3005 155.285 33.0937 155.916 32.7033C156.547 32.313 157.057 31.7547 157.388 31.0909C157.719 30.4271 157.859 29.6842 157.792 28.9454C157.724 28.2066 157.453 27.5012 157.007 26.9083L147.025 13.6005C146.653 13.1039 146.171 12.7007 145.617 12.423C145.062 12.1453 144.451 12.0007 143.831 12.0007C143.211 12.0007 142.599 12.1453 142.044 12.423C141.49 12.7007 141.008 13.1039 140.636 13.6005L130.659 26.9083C130.213 27.5015 129.941 28.2073 129.873 28.9464C129.806 29.6855 129.946 30.4288 130.278 31.0927C130.61 31.7566 131.12 32.3149 131.752 32.7049C132.383 33.0949 133.111 33.3013 133.853 33.3007H135.849L125.069 46.7762C124.11 47.982 123.923 49.6151 124.586 51.0045C125.252 52.382 126.65 53.2644 128.187 53.2644Z",
    fill: "#56B662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 53.2637V59.5712H143.807L143.803 12C144.423 12 145.034 12.1446 145.589 12.4223C146.143 12.7 146.626 13.1032 146.997 13.5998L156.979 26.9076C157.425 27.5005 157.696 28.2059 157.764 28.9447C157.831 29.6835 157.691 30.4264 157.36 31.0902C157.029 31.7539 156.519 32.3123 155.888 32.7026C155.258 33.0929 154.53 33.2998 153.789 33.3H151.792L162.569 46.7755C163.037 47.363 163.33 48.0706 163.415 48.8172C163.499 49.5638 163.372 50.3191 163.047 50.9965C162.722 51.6739 162.212 52.2459 161.577 52.6469C160.941 53.0479 160.206 53.2617 159.454 53.2637H147.799Z",
    fill: "#66CD73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.171 52.6731H144.166H148.16V60.2056H144.166H140.171V52.6731Z",
    fill: "#5C4C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.16 60.6609V52.6719H143.803V60.6609H148.16Z",
    fill: "#6F5B35"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.888 93.0249H123.567V100.969H133.625V93.0249H148.305C149.252 93.0223 150.178 92.753 150.978 92.248C151.779 91.7429 152.42 91.0224 152.83 90.1692C153.239 89.316 153.4 88.3647 153.294 87.4243C153.187 86.484 152.818 85.5927 152.228 84.8527L138.655 67.8797H141.169C142.103 67.8795 143.019 67.6189 143.814 67.1273C144.608 66.6357 145.25 65.9324 145.668 65.0964C146.085 64.2603 146.261 63.3246 146.176 62.394C146.091 61.4635 145.749 60.575 145.187 59.8282L132.615 43.0665C132.147 42.441 131.54 41.9332 130.841 41.5834C130.143 41.2336 129.373 41.0515 128.591 41.0515C127.81 41.0515 127.04 41.2336 126.342 41.5834C125.643 41.9332 125.036 42.441 124.568 43.0665L112.001 59.8282C111.439 60.5754 111.096 61.4643 111.012 62.3953C110.927 63.3263 111.104 64.2624 111.521 65.0986C111.939 65.9348 112.582 66.638 113.377 67.1293C114.173 67.6206 115.089 67.8804 116.024 67.8797H118.538L104.96 84.8527C103.753 86.3715 103.517 88.4283 104.351 90.1784C105.191 91.9135 106.952 93.0249 108.888 93.0249Z",
    fill: "#56B662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.585 93.0246V100.969H128.556L128.551 41.0513C129.332 41.0513 130.102 41.2334 130.801 41.5832C131.499 41.9329 132.106 42.4407 132.574 43.0662L145.147 59.828C145.708 60.5748 146.051 61.4633 146.135 62.3938C146.22 63.3243 146.044 64.2601 145.627 65.0961C145.21 65.9322 144.568 66.6354 143.773 67.1271C142.979 67.6187 142.063 67.8792 141.128 67.8795H138.614L152.187 84.8524C152.777 85.5924 153.147 86.4837 153.253 87.4241C153.36 88.3645 153.199 89.3158 152.789 90.169C152.38 91.0221 151.738 91.7426 150.938 92.2477C150.137 92.7528 149.211 93.0221 148.265 93.0246H133.585Z",
    fill: "#66CD73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.467 92.6177H128.551H133.635V101.333H128.551H123.467V92.6177Z",
    fill: "#5C4C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.635 101.333V92.6172H128.551V101.333H133.635Z",
    fill: "#6F5B35"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.458 102.06H164.485V111.274H176.151V102.06H193.177C194.275 102.057 195.349 101.744 196.277 101.158C197.206 100.573 197.95 99.7369 198.425 98.7474C198.9 97.7578 199.086 96.6544 198.963 95.5637C198.839 94.473 198.411 93.4393 197.727 92.581L181.984 72.8948H184.9C185.984 72.8946 187.046 72.5924 187.968 72.0222C188.889 71.4519 189.634 70.6362 190.118 69.6666C190.602 68.6969 190.806 67.6115 190.707 66.5323C190.609 65.453 190.212 64.4225 189.56 63.5563L174.978 44.1151C174.436 43.3897 173.731 42.8007 172.921 42.395C172.111 41.9893 171.218 41.7781 170.312 41.7781C169.406 41.7781 168.512 41.9893 167.702 42.395C166.892 42.8007 166.188 43.3897 165.645 44.1151L151.069 63.5563C150.417 64.4229 150.02 65.4539 149.922 66.5337C149.824 67.6135 150.029 68.6993 150.513 69.6692C150.998 70.6391 151.743 71.4547 152.666 72.0245C153.588 72.5942 154.651 72.8957 155.735 72.8948H158.652L142.903 92.581C141.503 94.3425 141.229 96.7282 142.197 98.7581C143.171 100.77 145.213 102.06 147.458 102.06Z",
    fill: "#56B662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.103 102.059V111.273H170.27L170.265 41.7773C171.171 41.7773 172.064 41.9886 172.874 42.3943C173.684 42.8 174.388 43.3889 174.931 44.1144L189.513 63.5556C190.165 64.4218 190.562 65.4523 190.66 66.5315C190.759 67.6108 190.554 68.6961 190.07 69.6658C189.587 70.6355 188.842 71.4512 187.92 72.0214C186.999 72.5916 185.937 72.8938 184.853 72.8941H181.936L197.679 92.5803C198.364 93.4385 198.792 94.4723 198.916 95.563C199.039 96.6537 198.853 97.7571 198.378 98.7466C197.903 99.7362 197.158 100.572 196.23 101.158C195.302 101.743 194.227 102.056 193.13 102.059H176.103Z",
    fill: "#66CD73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.139 102.059H170.312H176.485V112.641H170.312H164.139V102.059Z",
    fill: "#5C4C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.485 112.641V102.058H170.312V112.641H176.485Z",
    fill: "#6F5B35"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4742 91.2965C16.714 91.0204 16.8971 90.6997 17.0129 90.3529C17.1288 90.006 17.1752 89.6397 17.1495 89.275C17.1237 88.9102 17.0264 88.554 16.863 88.2269C16.6995 87.8997 16.4733 87.608 16.1971 87.3683C15.0368 86.3609 10.168 85.8228 10.168 85.8228C10.168 85.8228 11.1466 90.3558 12.5472 91.5736C13.1049 92.0573 13.8317 92.2997 14.5681 92.2478C15.3044 92.1958 15.99 91.8536 16.4742 91.2965Z",
    fill: "#66CD73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9591 92.8752C20.9591 92.5038 21.0764 92.0783 21.2868 91.6402C22.0714 92.1486 23.008 92.3693 23.9371 92.2647C24.8662 92.16 25.7303 91.7366 26.3822 91.0664C27.9415 89.468 29.1271 82.4487 29.1271 82.4487C29.1271 82.4487 22.4678 83.4929 20.5865 85.4248C20.0416 85.9852 19.671 86.6917 19.5198 87.4586C19.3685 88.2255 19.4431 89.0197 19.7344 89.7451C19.0099 90.8042 18.6592 91.9265 18.6592 92.8752V101.332H20.9591V92.8752Z",
    fill: "#66CD73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3303 99.1531C22.6776 99.1531 21.1607 99.7089 19.9726 100.636C18.7845 99.7089 17.2676 99.1531 15.615 99.1531C13.6305 99.1531 11.8417 99.9545 10.583 101.237L10.531 101.237C9.90263 101.237 9.29386 101.318 8.71533 101.468C8.1368 101.318 7.52803 101.237 6.89964 101.237C3.08907 101.237 1.81569 103.148 0 105.69H37.7664C35.2245 102.421 34.6774 101.237 30.8668 101.237C30.3946 101.237 29.9335 101.283 29.488 101.369C28.2242 100.01 26.3818 99.1531 24.3303 99.1531Z",
    fill: "#5C4C2C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3041 79.7338C59.9474 66.8146 74.0748 65.9573 90.0582 65.018",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9932 73.0547L90.1521 65.0142L80.0522 57.7856",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 88.8574,
    y: 16.0513,
    width: 89.4683,
    height: 100.282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 126.624,
    y: 26.7773,
    width: 77.3759,
    height: 90.8642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees);
export default __webpack_public_path__ + "static/media/trees.6e5cbaa77ccdf06a1a539dcb5f029220.svg";
export { ForwardRef as ReactComponent };